export const TRANSLATIONS_NE = {
  username: "Gebruikersnaam",
  password: "Wachtwoord",
  login: "INLOGGEN",
  registerMsg: "Nog niet geregistreerd?",
  registerMsg2: "Klik hier",
  modalMsg: "Onjuist wachtwoord en/of gebruikersnaam",
};
